(() => {
  const normalize = value => value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const initialize = root => {
    if (root.dataset.themeDirectoryReady) return;
    const input = root.querySelector('[data-theme-input]');
    const clear = root.querySelector('[data-theme-clear]');
    const empty = root.querySelector('[data-theme-empty]');
    const status = root.querySelector('[data-theme-status]');
    if (!input || !clear || !empty || !status) return;
    const items = [...root.querySelectorAll('[data-theme-item]')].map(element => ({element, title: normalize(element.dataset.themeTitle)}));
    const update = () => {
      const words = normalize(input.value).split(' ').filter(Boolean);
      let count = 0;
      items.forEach(item => {
        const matches = words.every(word => item.title.includes(word));
        item.element.hidden = !matches;
        if (matches) count += 1;
      });
      clear.disabled = input.value.length === 0;
      empty.hidden = count !== 0;
      status.textContent = status.dataset.countTemplate.replace('__COUNT__', String(count));
    };
    input.addEventListener('input', update);
    const reset = () => { input.value = ''; update(); input.focus(); };
    clear.addEventListener('click', reset);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape' && input.value) { event.preventDefault(); reset(); }
    });
    root.dataset.themeDirectoryReady = 'true';
    root.querySelector('[data-theme-search]').hidden = false;
    update();
  };
  const mount = scope => {
    if (scope.matches?.('[data-theme-directory]')) initialize(scope);
    scope.querySelectorAll('[data-theme-directory]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once: true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
